// Import global utils
import { isDefined } from '@automator/shared/utils/is-defined';

// Import utilities
import { getDOMElements } from '@automator/builder/_legacy/js/common/utilities';

/**
 * Returns the order of the actions.
 * This uses the DOM element to get the order
 *
 * @param {Boolean} includeNewActions Used to decide whether we should include the position of new actions (that don't exist yet)
 * @return {Array} The order of the actions. The elements are IDs
 */
const getActionsOrder = ( includeNewActions = false ) => {
	// Default response
	const instantActionsOrder = [],
	      delayedScheduledActionsOrder = [];

	// Get the actions metabox
	const $actionsMetabox = getDOMElements( 'metabox', {
		type: 'action',
	} ).get( 0 );

	// Get actions
	const $actions = $actionsMetabox.querySelectorAll( '.uap-item:not(.uap-item--closure)' );
	// Iterate them and get the order
	$actions.forEach( ( $action ) => {
		// Get the action ID
		const actionID = isDefined( $action.itemId ) ? $action.itemId : 'new_action';

		// Check if the action exists
		if ( ! includeNewActions && actionID === 'new_action' ) {
			return;
		}

		// If it's delayed or scheduled, add it on a separated array
		if ( 
			isDefined( UncannyAutomator.recipe.items[ actionID ] ) && 
			( UncannyAutomator.recipe.items[ actionID ].isScheduled || UncannyAutomator.recipe.items[ actionID ].isDelayed || UncannyAutomator.recipe.items[ actionID ].isDelayedCustom )
		) {
			delayedScheduledActionsOrder.push( actionID );
		}

		// Normal actions, and "new_action" go into the "instant actions" array
		instantActionsOrder.push( actionID );
	} );

	// Return both, but the instant actions first
	return [ ...instantActionsOrder, ...delayedScheduledActionsOrder ];
};

export default getActionsOrder;
